var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.585,30.063,12.52,16.281a2.846,2.846,0,0,0-5.039,0L.416,30.063a3.113,3.113,0,0,0,2.519,4.7h14.13A3.114,3.114,0,0,0,19.585,30.063ZM10,32.272a1.246,1.246,0,1,1,1.172-1.244A1.211,1.211,0,0,1,10,32.272ZM11.172,27.3a1.174,1.174,0,1,1-2.344,0V21.08a1.174,1.174,0,1,1,2.344,0Z",
    transform: "translate(0 -14.759)",
    fill: "#697384"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.cd0847a1510916c4bfb0894c97602ebb.svg";
export { ForwardRef as ReactComponent };